<template>
    <svg width="35" height="70" viewBox="0 0 35 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M34.5 68.75L0.750003 35L34.5 1.25" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>